import React, { useEffect, useState } from "react";
import {
  getCategory,
  getSubCategory,
  getSubCategoryMapping,
} from "../skucatalog/utils";
import Billingandmappingpresentational from "./billingandmappingpresentational";
import BillMappingPopup from "./billmappingpopup";
import ConformationPopup from "./conformationpopup";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification";

const BillingandMapping = () => {
  const [showPopupModal, setShowPopupModal] = useState(false);
  const [conformationPopupModal, setConformationPopupModal] = useState(false);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [filterform, setFilterForm] = useState([]);
  const [dataloading, SetDataloading] = useState(false);
  const [categorydataloading, SetCategoryDataloading] = useState(false);
  const [categoryMap, setCategoryMap] = useState("");
  const [maploading, setMaploading] = useState(false);
  const [buutonDiasble, setButtonDisable] = useState(true);
  const [temp, setTemp] = useState("");
  useEffect(() => {
    getcategory();
  }, []);

  const getcategory = () => {
    SetCategoryDataloading(true);
    getCategory()
      .then((res) => {
        SetCategoryDataloading(false);
        let response = res.data;
        let result = response.map((item) => {
          return { value: item.categoryId, label: item.categoryName };
        });
        setCategory(result);
      })
      .catch((err) => {
        SetCategoryDataloading(false);
        setCategory([]);
      });
  };
  const getSubcategoryList = (request) => {
    SetDataloading(true);
    getSubCategory(request)
      .then((res) => {
        SetDataloading(false);
        setSubCategory(res.data);
      })
      .catch((err) => {
        SetDataloading(false);
        setSubCategory([]);
      });
  };
  const getSubCategoryMapp = () => {
    let result = filterform.map((item) => item.subCategoryId);
    let final = {};
    final.subCategories = result;
    setMaploading(true);

    getSubCategoryMapping(categoryMap, final)
      .then((res) => {
        setMaploading(false);
        setConformationPopupModal(false);
        setButtonDisable(true);
        setSubCategory([]);
        getcategory();

        openNotificationWithIcon(
          notificationStrings.success,
          "Mapped Successfully"
        );
      })
      .catch((err) => {
        setMaploading(false);
        setConformationPopupModal(false);
      });
  };
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([{ ...selectedOption }]);
    }
  };

  const handleSearch = () => {
    setFilterForm([]);
    setButtonDisable(true);
    selectedOption.map((option) => {
      getSubcategoryList(option.value);
      setTemp(option.value);
    });
  };

  return (
    <>
      <Billingandmappingpresentational
        {...{
          temp,
          setShowPopupModal,
          category,
          handleChange,
          handleSearch,
          subcategory,
          setFilterForm,
          filterform,
          dataloading,
          setButtonDisable,
          buutonDiasble,
          categorydataloading,
        }}
      />
      <BillMappingPopup
        show={showPopupModal}
        setCategoryMap={setCategoryMap}
        categoryMap={categoryMap}
        close={() => {
          setConformationPopupModal(true);
          setShowPopupModal(false);
        }}
        popupData={category}
        setButtonDisable={setButtonDisable}
        buutonDiasble={buutonDiasble}
        title="Map to"
      />
      <ConformationPopup
        show={conformationPopupModal}
        onClose={() => {
          setConformationPopupModal(false);
        }}
        onFinish={getSubCategoryMapp}
        maploading={maploading}
      />
    </>
  );
};

export default BillingandMapping;
